var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRUDPage',{attrs:{"resultHeaders":_vm.resultHeaders,"resource":"info","title":"お知らせ配信一覧","schemaName":"Info","readonly":_vm.readonly,"id":_vm.id},scopedSlots:_vm._u([{key:"item.sendDateTime",fn:function({item}){return [_vm._v(" "+_vm._s(_vm._f("format")(item.sendDateTime))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }